import {
  ADMINISTRATION_ITEMS,
  AUTOMATIONS_ITEM,
  CUSTOM_FIELDS_ITEM,
  FEATURE_ITEMS,
  INTEGRATIONS_ITEM,
  USER_SETTINGS,
} from "#app/components/navigation/settings-nav-items";
import {
  MODULE_SCREENS,
  SCREEN_HOTKEYS,
  TILES,
} from "#app/components/navigation/module-rail/tiles";

/**
 * The label a workspace-relative route wears in the document title: the
 * rail tile, module screen or settings page that owns it. One read of the
 * navigation registries, so a renamed tile renames the tab with it.
 * Undefined for a route no registry names (a workflow board, a team page):
 * the title falls back to the app name.
 */
export function pageTitleFor(routePath: string): string | undefined {
  return (
    TILES.find((tile) => tile.route === routePath)?.label ??
    MODULE_SCREENS.find((screen) => screen.route === routePath)?.label ??
    SCREEN_HOTKEYS.find((screen) => screen.route === routePath)?.label ??
    [
      ...USER_SETTINGS,
      ...FEATURE_ITEMS,
      ...ADMINISTRATION_ITEMS,
      CUSTOM_FIELDS_ITEM,
      AUTOMATIONS_ITEM,
      INTEGRATIONS_ITEM,
    ].find((item) => item.route === routePath)?.label
  );
}
